import { type LucideIcon } from "lucide-react";
import type React from "react";

export const InfoSection = ({
  icon: Icon,
  title,
  children,
}: React.PropsWithChildren<{ icon: LucideIcon; title: string }>) => {
  return (
    <div className="flex flex-col gap-2">
      <header className="flex items-center gap-1">
        <Icon aria-hidden="true" className="pt-0.5" size={18} />
        <h2 className="text-xl font-semibold">{title}</h2>
      </header>
      <section>{children}</section>
    </div>
  );
};